var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"centerMapContent"},[_c('div',{ref:"basicMapbox",style:(_vm.mapSize),attrs:{"id":"centermap"}})])}
var staticRenderFns = []

export { render, staticRenderFns }